import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const CBackDrop = ({ cOpen, cHandleClose, cAllowClickToClose = false }) => {
  return (
    <Backdrop
      sx={{ color: "#FFFFFF", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={cOpen}
      onClick={cAllowClickToClose ? cHandleClose : undefined}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
};

export default CBackDrop;